import Axios from '@/assets/js/AxiosPlugin'

// 获取WebsocketToken
export const getWebsocketToken = params => { return Axios.post('/api/Admin/User/getWebsocketToken', params) }

// 实时收银
export const lastSpend = params => { return Axios.post('/api/Admin/Record/lastSpend', params) }

// 确认消费
export const confirmSpend = params => { return Axios.post('/api/Admin/Record/confirmSpend', params) }

// 扣款
export const handleSpend = params => { return Axios.post('/api/Admin/Member/spend', params) }

// 消费统计
export const spendStatistics = params => { return Axios.post('/api/Admin/Statistics/spend', params) }

// 查询优惠劵
export const searchCoupon = params => { return Axios.post('/api/Admin/Member/searchCoupon', params) }

// 兑换优惠劵
export const verifyCoupon = params => { return Axios.post('/api/Admin/Member/verifyCoupon', params) }

// 消费备注
export const setSpendRemark = params => { return Axios.post('/api/Admin/Record/setSpendRemark', params) }



// WEBPACK FOOTER //
// ./src/views/webpc/CashierDesk/RealApp/apis/index.js